export default __webpack_public_path__ + "static/media/blob-tracker.29d3105e.svg";